/// <amd-module name="TFS/Admin/Common/RestClient/Profile" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\profile.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Profile from "../Contracts/Profile";

export interface IProfileRestClient extends IVssRestClient {
    /**
     * Lookup up country/region based on provided IPv4, null if using the remote IPv4 address.
     * 
     * @param ip - 
     */
    getGeoRegion(ip: string): Promise<Profile.GeoRegion>;
    /**
     */
    getRegions(): Promise<Profile.ProfileRegions>;
}

class ProfileRestClient extends RestClientBase implements IProfileRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Lookup up country/region based on provided IPv4, null if using the remote IPv4 address.
     * 
     * @param ip - 
     */
    public async getGeoRegion(
        ip: string
        ): Promise<Profile.GeoRegion> {

        const queryValues: any = {
            ip: ip
        };

        return this.beginRequest<Profile.GeoRegion>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Profile/GeoRegion",
            queryParams: queryValues
        });
    }

    /**
     */
    public async getRegions(
        ): Promise<Profile.ProfileRegions> {

        return this.beginRequest<Profile.ProfileRegions>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/Profile/Regions"
        });
    }

}

export const ProfileClientName = "ProfileRegion-AdminArea.IProfileRestClient";

export function getProfileClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IProfileRestClient {
    return pageContext.getRestClient<IProfileRestClient>(ProfileClientName, options);
}

RestClients.add(ProfileClientName, { 
    factory: ProfileRestClient,
    options: {
        resourceAreaId: "8ccfef3d-2b87-4e99-8ccb-66e343d2daa8",
        serviceInstanceType: "00000041-0000-8888-8000-000000000000"
    }
});
